import { AUTO_LOANS } from '../..';

export const AUTO_LOAN_RATES = 'Auto Loan Rates';
export const LOAN_DETAILS = 'Loan Details';
export const LOAN_AMOUNT = 'Loan Amount';
export const DOWN_PAYMENT = 'Down Payment';
export const TRADE_IN_VALUE = 'Trade In Value';

export { AUTO_LOANS };
